export default {
  /**
   * @param {"companies" | "accounts"} page
   */
  setStartLoginPage(page) {
    sessionStorage.setItem('startLoginPage', page);
    this.set('startLoginPage', page);
  },
};
